import { tenantURL, tenantSettingURL,fiscalUrl } from "../Config/Url";
import axios from "axios";
import { serialize } from "object-to-formdata";
import { principals } from "../Config/Principals";
import { da } from "date-fns/locale";
import { max } from "date-fns";

const { ht, iskon } = principals;

export const tenantService = {
  get,
  getById,
  update,
  deleteTenant,
  getTenantSetting,
  updateTenantSetting,
  onboarding,
  publicOnboadring,
  getTenantPublicOnboadring,
  putTenantPublicOnboadring,
  addTenantToStore,
  activate,
  suspend,
  getTenantPos,
  updateLogo,
  deleteLogo,
  fiscal
};

async function suspend(tenantId, status, suspensionNote) {
  var data = { Note: suspensionNote }
  return axios
    .put(`${tenantURL}/${tenantId}/suspend`, {
      note: suspensionNote,
      suspended: status
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function activate(tenantId) {
  return axios
    .put(`${tenantURL}/activate/${tenantId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function get({
  searchText,
  isDeactivated,
  pageIndex,
  pageSize,
  sortName,
  isAsc,
}) {
  return axios
    .put(`${tenantURL}/search`, {
      searchText,
      isDeleted: isDeactivated,
      pageIndex,
      pageSize,
      sortName,
      isAsc,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function getById(tenantId) {
  return axios
    .get(`${tenantURL}/${tenantId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function update({
  tenantId,
  name,
  code,
  owner,
  taxNumber,
  street,
  streetNumber,
  streetNumberExtension,
  city,
  countryId,
  postalNumber,
  iban,
  fiscalObligation,
  taxObligation,
  taxNote,
  useAccounting,
}) {
  return axios
    .put(`${tenantURL}/${tenantId}`, {
      name,
      code,
      owner,
      taxNumber,
      street,
      streetNumber,
      streetNumberExtension,
      city,
      countryId,
      postalNumber,
      iban,
      fiscalObligation,
      taxObligation,
      taxNote,
      useAccounting,
      principalId: window.REACT_APP_VENDOR === "ht" ? ht : ht,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function deleteTenant(id) {
  return axios
    .delete(`${tenantURL}/${id}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getTenantSetting(tenantId) {
  return axios
    .get(`${tenantSettingURL}/${tenantId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function updateTenantSetting(data) {
  //return;
  console.log("data", data);
  return axios
    .put(`${tenantSettingURL}/${data.settings.tenantId}`, {
      closeArticleSearch: data.settings.closeArticleSearch,
      multiDraft: data.settings.multiDraft,
      cashDefault: data.settings.cashDefault,
      dataRetentionDays: data.data.dataRetentionDays,
      cashDiscount: Number(data.data.cashDiscount),
      useFiscalTip: data.settings.useFiscalTip,
      ediApiKey: data.data.ediApiKey,
      editApiPassword: data.data.ediApiPassword,
      dueDays:data.data.dueDays,
      maxProductNumber: data.data.maxProductNumber
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function onboarding(data) {
  return axios
    .post(tenantURL, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function publicOnboadring(data) {
  return axios
    .post(`${tenantURL}/onboarding`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function getTenantPublicOnboadring({ bearer, params }) {
  return axios
    .get(`${tenantURL}/onboarding`, {
      params,
      headers: {
        // "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + bearer,
      },
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function putTenantPublicOnboadring({ bearer, params, body }) {
  return axios
    .put(`${tenantURL}/onboarding`, body, {
      params,
      headers: {
        // "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + bearer,
      },
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function addTenantToStore(tenantId, storeId) {
  return axios
    .put(`${tenantURL}/${tenantId}/add/${storeId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getTenantPos(tenantId) {
  return axios
    .get(`${tenantURL}/${tenantId}/pos`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function updateLogo(tenantId, logo) {
  let Data = {
    tenantId,
    logo,
  };
  return axios
    .put(
      `${tenantURL}/logo/${tenantId}/update`,
      serialize({ tenantId, logo }),
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((res) => res)
    .catch((err) => err.response);
}

async function deleteLogo(tenantId) {
  return axios
    .delete(`${tenantURL}/logo/${tenantId}/remove`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function fiscal(oib) {

  var fiscalToken = "lFzLM6rsZhOAmWplY5xU"; // Replace with your actual fiscal token
  return axios
    .get(`${fiscalUrl}?daysBack=30&oib=${oib}`, {
      headers: {
        "X-FiscalToken": fiscalToken,
      },
    })
    .then((res) => res)
    .catch((err) => err.response);
}
